<ng-content select="[title]"></ng-content>
<select oninput="if(this.value){window.location.href = this.value}">
  @for (item of markets; track $index) {
  <option [attr.value]="item.baseUrl"
          [attr.selected]="item.catalog == market?.catalog ? '' : null"
          >{{item.name}}</option>
  }
</select>
<ng-content></ng-content>
